// useUserData.js
import { useEffect, useState } from "react";
import { auth, db } from "../components/Firebase";
import { doc, getDoc } from "firebase/firestore";

const useUserData = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const docRef = doc(db, "Users", user.uid);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        }
      }
    });

    return () => unsubscribe(); // Clean up the listener
  }, []);

  return userData;
};

export default useUserData;
